import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { adminActions } from "../store/adminSlice";
import Alert from "../components/Alert";
import validator from "../functions/Validator";
import URL from "../functions/URLString";

function ForgotPassword() {
  const dispatch = useDispatch();
  const stateAlert = useSelector((state) => state.admin.alert);
  const [email, setEmail] = useState("");
  const [alert, setAlert] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email && !isSubmitted) {
      try {
        const response = await fetch(URL + "/customer/forgot-password", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        });

        const data = await response.json();

        if (response.ok) {
          setIsSubmitted(true);
          dispatch(
            adminActions.addAlert({
              type: "success",
              title: "Success",
              message: "Password reset link sent to your email",
            })
          );
          setAlert(true);
          setTimeout(() => {
            navigate("/signin");
          }, 2000);
        } else {
          dispatch(
            adminActions.addAlert({
              type: "unsuccess",
              title: "Error",
              message: data.message || "Failed to send reset link",
            })
          );
          setAlert(true);
        }
      } catch (error) {
        dispatch(
          adminActions.addAlert({
            type: "unsuccess",
            title: "Error",
            message: "An error occurred. Please try again later.",
          })
        );
        setAlert(true);
      }
    } else if (!email) {
      dispatch(
        adminActions.addAlert({
          type: "unsuccess",
          title: "Error",
          message: "Please enter your email",
        })
      );
      setAlert(true);
    }
  };

  const signIn = () => {
    dispatch(adminActions.removeAlert());
    navigate("/signin");
  };

  return (
    <div className="w-full h-screen bg-white flex items-center justify-center">
      <div className="w-11/12 sm:w-80 h-11/12 bg-white rounded-md p-4 flex flex-col justify-center shadow-xl">
        <div className="flex justify-center mb-4">
          <img
            src={process.env.PUBLIC_URL + "/logo-sdl.png"}
            alt="Company Logo"
            className="h-16 w-auto"
          />
        </div>
        <form autoComplete="off" noValidate onSubmit={handleSubmit}>
          <div className="flex items-center flex-col">
            <h1 className="font-bold font-sans text-lg">Forgot Password</h1>
            <p className="text-sm font-sans text-grayy">
              Remember your password?
              <span
                className="text-gray-800 hover:underline cursor-pointer"
                onClick={signIn}
              >
                {" "}
                Sign in
              </span>
            </p>
            {alert && (
              <Alert
                type={stateAlert[0]}
                title={stateAlert[1]}
                message={stateAlert[2]}
              />
            )}
            <p className="flex flex-row w-full items-center py-4">
              <hr className="bg-grayy w-11/12 h-[1px]" />
              <span className="bg-white text-xs px-2 text-gray-500 font-sans">
                OR
              </span>
              <hr className="bg-grayy w-11/12 h-[1px]" />
            </p>
          </div>
          <div className="flex flex-col space-y-2">
            <p className="font-sans font-semibold text-gray-800 text-sm">
              Email
            </p>
            <input
              className="bg-gray-200 opacity-50 outline-none p-1 rounded-md"
              autoComplete="off"
              onChange={(e) => setEmail(validator(e.target.value))}
              value={email}
              type="email"
              placeholder="Enter your email address"
              disabled={isSubmitted}
            />
          </div>
          <div className="flex flex-col py-3">
            <button
              type="submit"
              className={`w-full rounded-md p-1 my-2 text-white ${
                isSubmitted
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-lightgreen hover:bg-darkgreen"
              }`}
              disabled={isSubmitted}
            >
              {isSubmitted ? "Reset Link Sent" : "Reset Password"}
            </button>
            <button
              type="button"
              className="w-full bg-lightgreen rounded-md p-1 my-2 text-white hover:bg-darkgreen"
              onClick={() => navigate("/signin")}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
